import loginIcon from 'assets/img/icons/login.svg';
import { useAuth0 } from "@auth0/auth0-react";
import useProfile from 'hooks/useProfile';

const PageHeaderLoginButton = () => {
  const {isAuthLoading} = useProfile();
  const {
    loginWithRedirect,
  } = useAuth0();

  const login = () => {
    loginWithRedirect();
  }


  return (
    <button className={`login ${isAuthLoading ? 'loading' : ''}`} disabled={isAuthLoading} onClick={login}>
      <img src={loginIcon} alt="" />
      Log in
    </button>
  )
}

export default PageHeaderLoginButton;
